import { Component, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Travel } from 'src/app/models/travel';
import { TravelService } from 'src/app/services/travel.service';
import { NgbDateNativeAdapter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class ScheduleComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  travels : Travel[];
  selectedTravel : Travel;
  editMode : number = 0;
  dateGas : String;
  timeGas : String;
  dateProd : String;
  timeProd : String;
  dateArrival : String;
  timeArrival : String;
  dateDelivery : String;
  timeDelivery : String;
  public loading = false;

  constructor(private travelServ:TravelService) { }

  ngOnInit() {
  
  }

  updateDate(){
    this.selectedTravel.gas_loading_date  = new Date(this.dateGas + ' ' + this.timeGas + ':00');
    this.selectedTravel.prd_loading_date  = new Date(this.dateProd + ' ' + this.timeProd + ':00');
    this.selectedTravel.arrival_date      = new Date(this.dateArrival + ' ' + this.timeArrival + ':00');
    this.selectedTravel.delivery_date     = new Date(this.dateDelivery + ' ' + this.timeDelivery + ':00');
        
    this.travelServ.updateTravel(this.selectedTravel).then(resp => {
      from(this.travels)
        .pipe(filter(x => resp.id == x.id)).subscribe(r => {
          r.gas_loading_date = new Date(resp.gas_loading_date.toString());
          r.prd_loading_date = new Date(resp.prd_loading_date.toString());
          r.arrival_date = new Date(resp.arrival_date.toString());
          r.delivery_date = new Date(resp.delivery_date.toString());
      })
    })
  }

  updateRelation(t : String){
    switch (t){
      case 'prod' :
        this.selectedTravel.gas_loading_date = new Date((Date.parse(this.dateProd + ' ' + this.timeProd) - 1800000)); 
        this.dateGas = this.selectedTravel.gas_loading_date == null ? '' : this.selectedTravel.gas_loading_date.toString().substr(0,10);
        this.timeGas = this.selectedTravel.gas_loading_date.getHours() + ':' + this.selectedTravel.gas_loading_date.getMinutes() + ':00';        
        break;
    }
  }
  
  editarViaje(t : Travel){
    this.selectedTravel = t;
    this.dateGas = this.selectedTravel.gas_loading_date == null ? '' : this.selectedTravel.gas_loading_date.toString().substr(0,10);
    this.timeGas = this.selectedTravel.gas_loading_date == null ? '' : this.selectedTravel.gas_loading_date.toString().substr(11,5);
    this.dateProd = this.selectedTravel.prd_loading_date == null ? '' : this.selectedTravel.prd_loading_date.toString().substr(0,10);
    this.timeProd = this.selectedTravel.prd_loading_date == null ? '' : this.selectedTravel.prd_loading_date.toString().substr(11,5);
    this.dateArrival = this.selectedTravel.arrival_date == null ? '' : this.selectedTravel.arrival_date.toString().substr(0,10);
    this.timeArrival = this.selectedTravel.arrival_date == null ? '' : this.selectedTravel.arrival_date.toString().substr(11,5);
    this.dateDelivery = this.selectedTravel.delivery_date == null ? '' : this.selectedTravel.delivery_date.toString().substr(0,10);
    this.timeDelivery = this.selectedTravel.delivery_date == null ? '' : this.selectedTravel.delivery_date.toString().substr(11,5);
    this.editMode = t.id;
  }

  search (){
    this.loading = true;
    this.travelServ.getTravelsByDates(this.date1, this.date2, {status: 'Cerrado'}).then(travels => {
      this.travels = travels;      
      this.loading = false;
    });
  }

}
